export default __webpack_public_path__ + "static/media/rightarrow.a6da8463.svg";